<template>
  <div>
    <a-upload
      list-type="picture-card"
      class="avatar-uploader"
      v-model="imageUrl"
      :show-upload-list="false"
      :customRequest="customRequest"
      :before-upload="beforeUpload"
      @change="handleChange"
    >
      <img v-if="imageUrl" :src="globalUrl + imageUrl" alt="avatar" />
      <div v-else>
        <a-icon :type="imgLoading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">
          选择文件
        </div>
      </div>
    </a-upload>
  </div>
</template>

<script>
import { requestPost } from '@/api/api'
function getBase64 (img, callback) {
  const reader = new FileReader()
  reader.addEventListener('load', () => callback(reader.result))
  reader.readAsDataURL(img)
}
export default {
  name: 'ImgUpload',
  props: {
    img: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 表单校验用字段
    // eslint-disable-next-line
    value: {
      type: String
    }
  },
  data () {
    return {
      imageUrl: ``,
      imgLoading: false
    }
  },
  watch: {
    value (val) {
      this.imageUrl = val
    },
    img (val) {
      this.imageUrl = val
    },
    imageUrl (val) {
      this.$emit('change', val)
    }
  },
  methods: {
    /**
     * 自定义上传图片
     *
     * @files
     */
    customRequest (files) {
      console.log('pdf:')
      console.log(files)
      console.log(files.file.type === 'application/pdf')
      const { file } = files
      const formData = new FormData()
      let uploadUrl = '/upload/image'
      // 如果文件为pdf，就用pdf上传路径
      if (files.file.type === 'application/pdf') {
          uploadUrl = '/upload/pdfs'
          formData.append('file', file)
       } else {
        formData.append('img', file)
       }
      requestPost(uploadUrl, formData)
        .then(res => {
          this.$notification.success({
              message: res.msg
          })
          this.imageUrl = res.result
          this.url = res.result
          this.$emit('change', this.url)
        })
        .finally(() => {
          this.imgLoading = !this.imgLoading
        })
    },
    // 修改图片
    handleChange (info) {
      if (info.file.status === 'uploading') {
        this.imgLoading = true
        return
      }
      if (info.file.status === 'done') {
        // Get this url from response in real world.
        getBase64(info.file.originFileObj, imageUrl => {
          this.imageUrl = imageUrl
          this.imgLoading = false
        })
      }
    },
    // 上传图片前检测格式及大小
    beforeUpload (file) {
      console.log(file)
      const isImg = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf' || file.type === 'image/webp' || file.type === 'image/gif' || file.type === 'image/svg+xml'
      if (!isImg) {
        this.$notification.error({
            message: '请上传JPG/PNG/WEBP/GIF/PDF格式文件!'
        })
      }
      const isLt = file.type === 'application/pdf' ? file.size / 1024 / 1024 < 100 : file.size / 1024 / 1024 < 2
      if (!isLt) {
        if (!file.type === 'application/pdf') {
           this.$notification.error({
            message: '图片必须小于2MB!'
        })
        } else {
          this.$notification.error({
            message: 'pdf文件必须小于100MB!'
          })
        }
      }
      return isImg && isLt
    }
  }
}
</script>

<style>
.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}
.ant-upload.ant-upload-select-picture-card > .ant-upload {
  padding: 0;
}
.avatar-uploader > .ant-upload img {
  max-width: 128px;
  max-height: 128px;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
</style>
